import * as React from "react";
import classNames from "classnames";
import { getQueryParameters } from "../../Wizards/Entities/QueryParametersHelper";

export enum EWizardLinterStatus {
    PleaseCheck,
    PleaseComplete,
    Checked,
    PleaseReview,
}

export interface IWizardLinter {
    status: EWizardLinterStatus;
    children: any;
    enabled?: boolean;
}

export const WizardLinter = (props: IWizardLinter) => {
    const getText = (option: EWizardLinterStatus) => {
        switch (option) {
            case EWizardLinterStatus.PleaseCheck:
                return "Please check";
            case EWizardLinterStatus.PleaseComplete:
                return "Please complete";
            case EWizardLinterStatus.Checked:
                return "Please complete";
            case EWizardLinterStatus.PleaseReview:
                return "Please review";
        }
    };

    const enabled = props.enabled != null ? props.enabled : Number(getQueryParameters()["quoteid"]) > 0;

    return (
        <div
            className={
                enabled
                    ? classNames("wizard-linter", {
                          "please-check": props.status == EWizardLinterStatus.PleaseCheck,
                          "please-complete": props.status == EWizardLinterStatus.PleaseComplete,
                          "please-review": props.status == EWizardLinterStatus.PleaseReview,
                          checked: props.status == EWizardLinterStatus.Checked,
                      })
                    : ""
            }
        >
            <div className="wl-fields">{props.children}</div>
            {enabled && <div className="wl-info">{getText(props.status)}</div>}
        </div>
    );
};
